/* src/components/home/ListingsSlider.jsx */
import React from 'react';
import { useTranslation } from 'react-i18next';
import HorizontalScroller from './HorizontalScroller';
import ListingCard from '../../components/ListingCard';

function normalizeItem(x){
  if (!x) return null;
  const cover =
    x.cover_url ||
    x.cover_thumb ||
    x.image ||
    x.img ||
    x.images?.find?.(m => m?.is_main)?.url ||
    x.images?.[0]?.url ||
    null;

  return {
    ...x,
    id: x.id ?? x.slug ?? x.uid ?? Math.random(),
    title: x.title || x.name || x.title_ru || x.title_en || null,
    cover_url: cover,
  };
}

export default function ListingsSlider({
  items = [],
  perViewDesktop = 4,
  perViewTablet  = 3,
  perViewMobile  = 1,
  perViewTiny    = 1,
  itemMin = 260,
  itemMax = 330,
  pad = 8,
  gap = 12,
}) {
  const { t, i18n } = useTranslation();

  const isCompactDesktop = perViewDesktop <= 2;
  const maxWidthValue = isCompactDesktop
    ? perViewDesktop * itemMax + gap * (perViewDesktop - 1) + pad * 2
    : '100%';
  const shouldLimitDesktop = !isCompactDesktop;

  const baseRaw = (Array.isArray(items) ? items : [])
    .map(normalizeItem)
    .filter(Boolean);

  const base = baseRaw.map((it, idx) => ({
    ...it,
    title: it.title || t('common.objectN', 'Object {{n}}', { n: idx + 1 }),
  }));

  // Показываем только карточки с реальным изображением
  const list = base.filter(it => !!it.cover_url);
  if (!list.length) return null;

  return (
    <HorizontalScroller
      perViewDesktop={perViewDesktop}
      perViewTablet={perViewTablet}
      perViewMobile={perViewMobile}
      perViewTiny={perViewTiny}
      itemMin={itemMin}
      itemMax={itemMax}
      maxWidth={maxWidthValue}
      centered
      pad={pad}
      gap={gap}
      limitDesktopWidth={shouldLimitDesktop}
    >
      {list.map((it) => (
        <div key={String(it.id)}>
          <ListingCard item={it} lng={i18n.language} />
        </div>
      ))}
    </HorizontalScroller>
  );
}
